module.exports = __webpack_public_path__ + "static/media/foreground.534421b2.gif";